module.exports = __webpack_public_path__ + "static/media/sample2.329be047.png";